import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "ms-2" }

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { HopDongService } from '@/core/services/HopDong.service';
import { IHopDongResponseBase, IPhieuNhapKhoResponseBase, IVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { PhieuNhapKhoService } from '@/core/services/PhieuNhapKho.service';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { swalErrNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import BienBanKiemNghiemPrintModal
  from '@/components/shared/bien-ban-kiem-nghiem-print-modal/BienBanKiemNghiemPrintModal.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import DanhSachVatTuTable from '@/views/crafted/pages/vat-tu/danh-sach-vat-tu-table/DanhSachVatTuTable.vue';
import useHopDong from '@/core/hooks/use-hop-dong';
import usePhieuNhap from '@/core/hooks/usePhieuNhap';


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const {
  params: {
    id: idPhieuNhapKho,
  },
} = useRoute();

const { back } = useRouter();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

setCurrentPageTitle('Phiếu nhập kho');

const phieuNhapDetail = ref<IPhieuNhapKhoResponseBase | null>(null);

const { formatDisplayingDate } = useDateTime();

const { endLoading, startLoading } = useLoading();

const { editable, goToEditPhieuNhap } = usePhieuNhap();

const showEdit = computed(() => editable(phieuNhapDetail.value));

const fetchPhieuNhapKho = async () => {
  try {
    const {
      data: {
        data,
      },
    } = await PhieuNhapKhoService.get(+idPhieuNhapKho);

    phieuNhapDetail.value = data;
  } catch (e) {
    await endLoading();

    await swalErrNotification(
      e,
      'Có lỗi xảy ra',
    );
  }
};

const hopDongDetail = ref<IHopDongResponseBase | null>(null);

const fetchHopDong = async () => {
  if (phieuNhapDetail.value?.id_hop_dong) {
    const { data: { data } } = await HopDongService.fetchContractDetail(phieuNhapDetail.value.id_hop_dong);

    hopDongDetail.value = data;
  }
}

const isHoanThanh = computed<boolean>(() => !!phieuNhapDetail.value?.hoan_thanh);

const isPhieuNhapApproved = computed<boolean>(() => !!phieuNhapDetail.value?.is_approved);

const bienBanPrintModal = ref(false);

onMounted(async () => {
  await startLoading();

  await fetchPhieuNhapKho();

  await fetchHopDong();

  await endLoading();
});

const taiKhoanDisplay = computed(() => `${phieuNhapDetail.value?.ma_tk_co}/${phieuNhapDetail.value?.ma_ct_co} - ${phieuNhapDetail.value?.ten_tk_co}`);

const vatTuItems = computed<IVatTuResponseBase[]>(() => {
  if (!phieuNhapDetail.value) return [];

  return phieuNhapDetail.value.vat_tu_nhap_kho.map((vatTu) => {
    return {
      ...vatTu,
      don_gia: vatTu.pivot.don_gia,
      so_luong: vatTu.pivot.so_luong,
    }
  });
});

const { loaiHopDong } = useHopDong();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (phieuNhapDetail.value?.bien_ban_kiem_nghiem)
      ? (_openBlock(), _createBlock(BienBanKiemNghiemPrintModal, {
          key: 0,
          "bien-ban-data": phieuNhapDetail.value.bien_ban_kiem_nghiem,
          "hop-dong-data": hopDongDetail.value,
          "is-modal-open": bienBanPrintModal.value,
          onOnCloseModal: _cache[0] || (_cache[0] = ($event: any) => (bienBanPrintModal.value = false))
        }, null, 8, ["bien-ban-data", "hop-dong-data", "is-modal-open"]))
      : _createCommentVNode("", true),
    _createVNode(PageRowLayout, null, _createSlots({
      "page-row-header": _withCtx(() => [
        _createTextVNode("Chi tiết")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(ButtonCustom, {
          "button-type": _unref(ButtonsType).BACK,
          onClick: _unref(back)
        }, null, 8, ["button-type", "onClick"]),
        (phieuNhapDetail.value && showEdit.value)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: _unref(goToEditPhieuNhap)(phieuNhapDetail.value)
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).EDIT,
                  "color-type": _unref(ButtonTypeColors).SUCCESS
                }, null, 8, ["button-type", "color-type"])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (phieuNhapDetail.value)
        ? {
            name: "page-row-content",
            fn: _withCtx(() => [
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("ID:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.id), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số phiếu:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.so_phieu ?? '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (phieuNhapDetail.value.id_bien_ban_kiem_nghiem)
                ? (_openBlock(), _createBlock(DivRow, {
                    key: 0,
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DivCol, {
                        cols: 2,
                        class: "d-flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LabelCustom, { "is-text-muted": true }, {
                            default: _withCtx(() => [
                              _createTextVNode("B/b kiểm nghiệm:")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        cols: 4,
                        class: "d-flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ButtonCustom, {
                            "button-type": _unref(ButtonsType).FA_PRINT,
                            "color-type": _unref(ButtonTypeColors).INFO,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (bienBanPrintModal.value = true))
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode(_toDisplayString(phieuNhapDetail.value.bien_ban_kiem_nghiem?.so_bien_ban), 1)
                            ]),
                            _: 1
                          }, 8, ["button-type", "color-type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        cols: 2,
                        class: "d-flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LabelCustom, { "is-text-muted": true }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hợp đồng:")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        cols: 4,
                        class: "d-flex"
                      }, {
                        default: _withCtx(() => [
                          (hopDongDetail.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_RouterLink, {
                                    to: {
                  name: 'chi-tiet-hop-dong',
                  params: {
                    id: phieuNhapDetail.value.id_hop_dong
                  },
                },
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(hopDongDetail.value.so_hop_dong), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ]),
                                _createElementVNode("span", _hoisted_1, " (" + _toDisplayString(_unref(loaiHopDong)(hopDongDetail.value)) + ") ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("-")
                              ], 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Nhập vào kho:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 4,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      (phieuNhapDetail.value.kho)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: {
              name: 'chi-tiet-kho',
              params: {
                id: phieuNhapDetail.value.id_kho,
              },
            },
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(phieuNhapDetail.value.kho.ten_kho), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tài khoản:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 4,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value?.ma_ct_co ? taiKhoanDisplay.value : '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Hoàn thành?")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: isHoanThanh.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isHoanThanh).value = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Đã duyệt?")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: isPhieuNhapApproved.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isPhieuNhapApproved).value = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày hoàn thành:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.ngay_hoan_thanh
              ? _unref(formatDisplayingDate)(new Date(phieuNhapDetail.value.ngay_hoan_thanh))
              : '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày hợp đồng:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(phieuNhapDetail.value?.ngay_hop_don ? new Date(phieuNhapDetail.value.ngay_hop_dong) : null)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số hoá đơn:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.so_hoa_don ?? '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 2,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày hoá đơn:")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.ngay_hoa_don
              ? _unref(formatDisplayingDate)(new Date(phieuNhapDetail.value.ngay_hoa_don))
              : '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (phieuNhapDetail.value?.vat_tu_nhap_kho.length)
      ? (_openBlock(), _createBlock(PageRowLayout, { key: 1 }, {
          "page-row-header": _withCtx(() => [
            _createTextVNode("Vật tư")
          ]),
          "page-row-content": _withCtx(() => [
            _createVNode(DanhSachVatTuTable, {
              "cur-page": 1,
              items: vatTuItems.value,
              "show-price": true,
              "vat-tu-phieu-nhap-detail": true
            }, null, 8, ["items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})